// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-fields-dashboard {
  padding: 20px 0;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e0e0e0;
}

/* Quick Actions */
.quick-actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
  margin-bottom: 30px;
}

.action-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  text-decoration: none;
  color: #333;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.action-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-decoration: none;
  color: #007bff;
  border-color: #007bff;
}

.action-card svg {
  font-size: 24px;
}

/* Statistics Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 20px;
  transition: all 0.3s ease;
}

.stat-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  flex-shrink: 0;
}

.stat-content h3 {
  margin: 0;
  font-size: 32px;
  font-weight: bold;
  color: #333;
}

.stat-content p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

/* Dashboard Row */
.dashboard-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 30px;
}

@media (max-width: 768px) {
  .dashboard-row {
    grid-template-columns: 1fr;
  }
}

/* Dashboard Card */
.dashboard-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
}

.dashboard-card h4 {
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
  font-size: 18px;
  font-weight: 600;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}

/* Field Types Chart */
.field-types-chart {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.type-bar {
  display: flex;
  align-items: center;
  gap: 10px;
}

.type-label {
  width: 80px;
  font-size: 13px;
  color: #666;
  text-transform: capitalize;
}

.type-progress {
  flex: 1 1;
  height: 24px;
  background: #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
}

.type-fill {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  font-weight: bold;
  transition: width 0.3s ease;
}

/* Page Assignments */
.page-assignments {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.page-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  transition: background 0.2s ease;
}

.page-item:hover {
  background: #e9ecef;
}

.page-name {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.page-count {
  font-size: 12px;
}

/* Recent Fields Table */
.recent-fields {
  overflow-x: auto;
}

.recent-fields table {
  margin-bottom: 0;
}

.recent-fields th {
  border-top: none;
  font-weight: 600;
  color: #666;
  font-size: 13px;
  text-transform: uppercase;
}

.recent-fields td {
  vertical-align: middle;
  font-size: 14px;
}

.recent-fields code {
  background: #f8f9fa;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
}

/* Responsive */
@media (max-width: 576px) {
  .quick-actions {
    grid-template-columns: 1fr 1fr;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .dashboard-header {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/CustomFields/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;AACF","sourcesContent":[".custom-fields-dashboard {\n  padding: 20px 0;\n}\n\n.dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n/* Quick Actions */\n.quick-actions {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 15px;\n  margin-bottom: 30px;\n}\n\n.action-card {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 20px;\n  text-align: center;\n  text-decoration: none;\n  color: #333;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.action-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  text-decoration: none;\n  color: #007bff;\n  border-color: #007bff;\n}\n\n.action-card svg {\n  font-size: 24px;\n}\n\n/* Statistics Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.stat-card {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  transition: all 0.3s ease;\n}\n\n.stat-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.stat-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.stat-content h3 {\n  margin: 0;\n  font-size: 32px;\n  font-weight: bold;\n  color: #333;\n}\n\n.stat-content p {\n  margin: 0;\n  color: #666;\n  font-size: 14px;\n}\n\n/* Dashboard Row */\n.dashboard-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n@media (max-width: 768px) {\n  .dashboard-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Dashboard Card */\n.dashboard-card {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.dashboard-card h4 {\n  margin-top: 0;\n  margin-bottom: 20px;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n/* Field Types Chart */\n.field-types-chart {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.type-bar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.type-label {\n  width: 80px;\n  font-size: 13px;\n  color: #666;\n  text-transform: capitalize;\n}\n\n.type-progress {\n  flex: 1;\n  height: 24px;\n  background: #f0f0f0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.type-fill {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 12px;\n  font-weight: bold;\n  transition: width 0.3s ease;\n}\n\n/* Page Assignments */\n.page-assignments {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.page-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  transition: background 0.2s ease;\n}\n\n.page-item:hover {\n  background: #e9ecef;\n}\n\n.page-name {\n  font-size: 14px;\n  color: #333;\n  font-weight: 500;\n}\n\n.page-count {\n  font-size: 12px;\n}\n\n/* Recent Fields Table */\n.recent-fields {\n  overflow-x: auto;\n}\n\n.recent-fields table {\n  margin-bottom: 0;\n}\n\n.recent-fields th {\n  border-top: none;\n  font-weight: 600;\n  color: #666;\n  font-size: 13px;\n  text-transform: uppercase;\n}\n\n.recent-fields td {\n  vertical-align: middle;\n  font-size: 14px;\n}\n\n.recent-fields code {\n  background: #f8f9fa;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 12px;\n}\n\n/* Responsive */\n@media (max-width: 576px) {\n  .quick-actions {\n    grid-template-columns: 1fr 1fr;\n  }\n  \n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .dashboard-header {\n    flex-direction: column;\n    gap: 15px;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
